import { reactive } from 'vue';

export const global = reactive({
    candidate: null,
    version: "1.61",
    mode: "dark"
});

// export default {
//     methods: {
//         test(str) {
//             return "GLOBAL: " + str;
//         }
//     }
// };

// https://vuejs.org/guide/scaling-up/state-management.html#simple-state-management-with-reactivity-api

// Global function
// https://jennipulli.se/notes/2021/01/27/global-functions-in-vue3/